import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
import { emit } from '@amityeko/pbc-core/dist/utilities/event';
import '../button';
import '../dropdown';
import '../typography/tg-body-two';
import { generateSelectionColors } from './helpers';
import styles from './styles';
/**
 * @dependency amityeko-tg-body-two
 * @dependency amityeko-button
 *
 * @slot prefix - The icon or image is to be shown on the left side of the button( image or amityeko-icon is expected)
 * @slot - Chip's label.
 * @slot suffix - The icon is to be shown on the right side of the button(amityeko-icon is expected)
 * @slot button-icon - The icon to be shown in the right side button (amityeko-icon is expected).
 *
 * @event amityeko-click-chip - Emitted when a chip is clicked. Triggered only when the `click`
 *        event is allowed.
 * @event amityeko-select-chip-dropdown {{ value }}  - Emitted when a dropdown item is selected.
 */
export default class AmityekoChip extends LitElement {
    constructor() {
        super(...arguments);
        this.clickable = false;
        this.selected = false;
        this.disabled = false;
        this.dropdownOptions = [];
    }
    _onClickChip(e) {
        if (!this.clickable) {
            e.stopPropagation();
            return;
        }
        if (e.target.classList.contains('chip--selected')) {
            return;
        }
        emit(this, 'amityeko-click-chip');
    }
    _onSelectChipDropdown(e) {
        e.stopPropagation();
        emit(this, 'amityeko-select-chip-dropdown', { detail: e.detail });
    }
    render() {
        const shouldShowDropdown = Boolean(this.dropdownOptions.length);
        return html `
      <div
        part="base"
        class="chip ${classMap({
            'chip--clickable': this.clickable,
            'chip--clickable-ui': this.clickable && !shouldShowDropdown,
            'chip--selected': this.selected,
        })}"
        style=${styleMap({ ...generateSelectionColors(this.selectionColor) })}
        ?disabled=${this.disabled}
        @click=${this._onClickChip}
      >
        <slot name="prefix"></slot>
        <amityeko-tg-body-two class="chip__label"><slot></slot></amityeko-tg-body-two>
        <slot name="suffix"></slot>
        ${shouldShowDropdown
            ? html `
              <amityeko-dropdown
                placement="bottom"
                .options=${this.dropdownOptions}
                @click=${(e) => {
                // We do not need the click event from the dropdown and its content
                // to be propagated to the Chip element container.
                e.stopPropagation();
            }}
                @amityeko-select=${this._onSelectChipDropdown}
              >
                <amityeko-button
                  class="chip__button"
                  variant="ghost"
                  circle
                  .customColor=${this.selected ? this.selectionColor : undefined}
                  ?disabled=${this.disabled}
                >
                  <slot name="button-icon"></slot>
                </amityeko-button>
              </amityeko-dropdown>
            `
            : null}
      </div>
    `;
    }
}
AmityekoChip.styles = styles;
__decorate([
    property({ type: Boolean })
], AmityekoChip.prototype, "clickable", void 0);
__decorate([
    property({ type: Boolean })
], AmityekoChip.prototype, "selected", void 0);
__decorate([
    property({ type: Boolean })
], AmityekoChip.prototype, "disabled", void 0);
__decorate([
    property({ type: Array })
], AmityekoChip.prototype, "dropdownOptions", void 0);
__decorate([
    property()
], AmityekoChip.prototype, "selectionColor", void 0);
if (!customElements.get('amityeko-chip')) {
    customElements.define('amityeko-chip', AmityekoChip);
}
//# sourceMappingURL=index.js.map